<template>
  <el-aside class="left" width="400px">
    <Logo :height="60"/>
    <Scenes />
    <Actions />
  </el-aside>
</template>

<script>
import Scenes from './LeftSidebar/Scenes.vue';
import Actions from './LeftSidebar/Actions.vue';
import Logo from './Common/Logo.vue'

export default {
  components: {
    Logo,
    Scenes,
    Actions,
  },
};
</script>

<style lang="less" scoped>
.logo {
  text-align: center;
  margin-bottom: 15px;
}

.left {
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    max-height: 100vh;
    position: relative;
    background: #fff;
    position: relative;
    border-right: 2px solid #f1f4fa;
  }

  .box-card + .box-card {
    margin-top: 10px;
  }
}
.box-card {
  font-size: 14px;
  span {
    display: block;
  }
  .el-input-number {
    margin-left: 10px;
    width: 100px;
  }
  .el-card__body {
    .item + .item {
      margin-top: 5px;
    }
  }
  &.text {
    font-size: 12px;
    + .text {
      margin-top: 15px;
    }
  }
}
</style>
